export default __webpack_public_path__ + "static/media/sensotrend_dashboard_sharing.2ae3ae21.png";